export default __webpack_public_path__ + "static/media/chat_avatar_4.a6804131.svg";